import React from 'react';
import styled, { keyframes } from 'styled-components';
import { token } from '@zillow/constellation';

const Rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const SpinnerRing = styled.div<{ isSmall: boolean }>`
  margin: auto;
  box-sizing: border-box;
  width: ${props => (props.isSmall ? '20px' : '40px')};
  height: ${props => (props.isSmall ? '20px' : '40px')};
  border-radius: 50%;
  border-style: solid;
  border-width: ${props => (props.isSmall ? '3px' : '5px')};
  border-color: ${token('colors.blue400')} ${token('colors.blue400')}
    ${token('colors.gray400')} ${token('colors.gray400')};
  animation: ${Rotate} 0.8s linear infinite;
`;

export interface Props {
  small: boolean;
  className?: string;
}

function Spinner({ small, className }: Props) {
  return <SpinnerRing isSmall={small} className={className} />;
}

Spinner.defaultProps = {
  small: false,
};

export default Spinner;
